module.exports = __webpack_public_path__ + "static/media/lens_classic-Charm.f8989eb5.png";